import { Badge, Center, Loader, Tabs } from '@mantine/core';
import { IconArrowLeft, IconArrowRight, IconChartBar, IconDatabase, IconExternalLink } from '@tabler/icons-react';
import { useState } from 'react';

import { useRequestDetails } from '@admin/hooks';
import { DatabaseChangesTab } from './DatabaseChangesTab';
import { ExternalCallsTab } from './ExternalCallsTab';
import { OverviewTab } from './OverviewTab';
import { RequestTab } from './RequestTab';
import { ResponseTab } from './ResponseTab';

interface RequestDetailsModalProps {
  requestId: string;
  onClose: () => void;
}

export const RequestDetails = ({ requestId, onClose }: RequestDetailsModalProps) => {
  const [activeTab, setActiveTab] = useState<string>('overview');
  const { data, isLoading } = useRequestDetails(requestId);

  return (
    <>
      {isLoading ? (
        <Center p="xl">
          <Loader size="lg" />
        </Center>
      ) : (
        <Tabs value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="overview" leftSection={<IconChartBar size={16} />}>
              Overview
            </Tabs.Tab>
            <Tabs.Tab value="request" leftSection={<IconArrowRight size={16} />}>
              Request
            </Tabs.Tab>
            <Tabs.Tab value="response" leftSection={<IconArrowLeft size={16} />}>
              Response
            </Tabs.Tab>
            <Tabs.Tab
              value="external"
              leftSection={<IconExternalLink size={16} />}
              rightSection={data?.externalCalls?.length > 0 && <Badge size="sm">{data.externalCalls.length}</Badge>}
            >
              External Calls
            </Tabs.Tab>
            <Tabs.Tab
              value="database"
              leftSection={<IconDatabase size={16} />}
              rightSection={data?.dbChanges?.length > 0 && <Badge size="sm">{data.dbChanges.length}</Badge>}
            >
              DB Changes
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="overview" pt="md">
            {data && <OverviewTab data={data} />}
          </Tabs.Panel>

          <Tabs.Panel value="request" pt="md">
            {data && <RequestTab request={data.request} />}
          </Tabs.Panel>

          <Tabs.Panel value="response" pt="md">
            {data && <ResponseTab request={data.request} />}
          </Tabs.Panel>

          <Tabs.Panel value="external" pt="md">
            {data && <ExternalCallsTab externalCalls={data.externalCalls} />}
          </Tabs.Panel>

          <Tabs.Panel value="database" pt="md">
            {data && <DatabaseChangesTab dbChanges={data.dbChanges} />}
          </Tabs.Panel>
        </Tabs>
      )}
    </>
  );
};
